import DetailsNameTableData from 'app/components/management/common/details-name-table-data/details-name-table-data';
import DetailsValueTableData from 'app/components/management/common/details-value-table-data/details-value-table-data';
import CollapsibleContentPreview from 'app/components/management/common/content-view/collapse-content-preview';
import DetailsTableRow from 'app/components/management/common/details-table-row/details-table-row';
import React from 'react';
import { IntegrationInstructions } from 'app/components/management/common/plugins/custom/integration-instructions';

export const ViewSegment = ({ metadata }: { metadata: any }) => {
  return (
    <DetailsTableRow>
      <DetailsNameTableData>Backend API integration</DetailsNameTableData>
      <DetailsValueTableData>
        <CollapsibleContentPreview
          maxWidth={'450px'}
          htmlContent={<IntegrationInstructions url={metadata?.verifyURL || ''} />}
        />
      </DetailsValueTableData>
    </DetailsTableRow>
  );
};
